[
 {
  "id": "general-denial-unverified",
  "text": "Prepare a General Denial (PLD-050). It is enough here because the complaint is not verified, but it only puts in issue the material allegations of the complaint.",
  "rules": ["CCP 431.30(d)"],
  "phase": "prepare",
  "when": "pleading = general and verified = no",
  "forms": ["ca-pld-050"]
 },
 {
  "id": "general-denial-limited",
  "text": "Prepare a General Denial (PLD-050). It is enough here because this is a limited civil case, but it only puts in issue the material allegations of the complaint.",
  "rules": ["CCP 431.30(d)"],
  "note": "Not if the claim was assigned to a third party for collection: then the denials must be made positively or on information and belief, even in a limited civil case (CCP 431.30(d)).",
  "phase": "prepare",
  "when": "pleading = general and verified = yes and economicLitigation",
  "forms": ["ca-pld-050"]
 },
 {
  "id": "general-denial-defenses",
  "text": "Add any affirmative defenses (new matter) to it, each separately stated.",
  "rules": ["CCP 431.30(b)(2)", "CCP 431.30(g)"],
  "phase": "prepare",
  "when": "pleading = general",
  "forms": []
 },
 {
  "id": "council-form-pi",
  "text": "Prepare the answer on PLD-PI-003.",
  "rules": ["CCP 425.12(a)", "CRC 1.35(a)"],
  "phase": "prepare",
  "when": "pleading = form and not ud and kind = pi",
  "forms": ["ca-pld-pi-003"]
 },
 {
  "id": "council-form-contract",
  "text": "Prepare the answer on PLD-C-010.",
  "rules": ["CCP 425.12(a)", "CRC 1.35(a)"],
  "phase": "prepare",
  "when": "pleading = form and not ud and kind = contract",
  "forms": ["ca-pld-c-010"]
 },
 {
  "id": "council-form-ud",
  "text": "Prepare the answer on UD-105.",
  "rules": ["CCP 425.12(a)", "CRC 1.35(a)"],
  "phase": "prepare",
  "when": "pleading = form and ud",
  "forms": ["ca-ud-105"]
 },
 {
  "id": "pleading-paper",
  "text": "Prepare the answer on pleading paper in the format the rules require, including the first page layout.",
  "rules": ["CRC 2.100-2.119", "CRC 2.111"],
  "phase": "prepare",
  "when": "pleading = paper",
  "forms": []
 },
 {
  "id": "limited-caption",
  "text": "Put the words \"Limited Civil Case\" in the caption.",
  "rules": ["CRC 2.111(10)", "CCP 422.30(b)"],
  "phase": "prepare",
  "when": "pleading = paper and limited",
  "forms": []
 },
 {
  "id": "answer-caption",
  "text": "Below the case number, state that the paper is an answer. In a case with several parties, say whose complaint it answers and which complaint. The case title can be shortened to the first party on each side, with an indication of the others.",
  "rules": ["CRC 2.111(4)", "CRC 2.111(6)", "CCP 422.40"],
  "phase": "prepare",
  "when": "pleading = paper",
  "forms": []
 },
 {
  "id": "positive-denials",
  "text": "Deny the allegations positively or on information and belief: the complaint is verified, so a general denial isn't enough. Where the defendant lacks information or belief to answer an allegation, say so and deny on that ground.",
  "rules": ["CCP 431.30(d)", "CCP 431.30(e)", "CCP 431.30(f)"],
  "phase": "prepare",
  "when": "pleading != general and verified and not economicLitigation",
  "forms": []
 },
 {
  "id": "denials",
  "text": "Deny the material allegations controverted, generally or specifically, by reference to paragraphs or by admitting some and denying the rest.",
  "rules": ["CCP 431.30(b)(1)", "CCP 431.30(d)", "CCP 431.30(f)"],
  "note": "Not if the claim was assigned to a third party for collection: then the denials must be made positively or on information and belief, even in a limited civil case (CCP 431.30(d)).",
  "noteWhen": "verified and economicLitigation",
  "phase": "prepare",
  "when": "pleading != general and not (verified and not economicLitigation)",
  "forms": []
 },
 {
  "id": "deemed-admitted",
  "text": "Every material allegation of the complaint that the answer doesn't deny is taken as true.",
  "rules": ["CCP 431.20(a)"],
  "phase": "prepare",
  "when": "pleading != general",
  "forms": []
 },
 {
  "id": "defenses",
  "text": "State each affirmative defense (new matter) separately, referring to the causes of action it answers.",
  "rules": ["CCP 431.30(b)(2)", "CCP 431.30(g)"],
  "phase": "prepare",
  "when": "pleading != general",
  "forms": []
 },
 {
  "id": "numbering",
  "text": "Head each separately stated cause of action, count or defense with its number (\"first affirmative defense\"), its nature, the party asserting it if the pleading is for more than one party, and the parties it is directed to.",
  "rules": ["CRC 2.112"],
  "phase": "prepare",
  "when": "pleading != form",
  "forms": []
 },
 {
  "id": "limitations",
  "text": "A statute of limitations defense can be pleaded generally, by stating that the cause of action is barred by the section (and subdivision) of the Code of Civil Procedure relied on.",
  "rules": ["CCP 458"],
  "phase": "prepare",
  "forms": []
 },
 {
  "id": "waiver",
  "text": "An objection to the complaint that isn't raised by demurrer or in the answer is waived, except that the court has no jurisdiction of the subject of the cause of action or that the complaint doesn't state facts sufficient to constitute a cause of action.",
  "rules": ["CCP 430.80(a)"],
  "phase": "prepare",
  "forms": []
 },
 {
  "id": "no-affirmative-relief",
  "text": "Don't ask for affirmative relief in the answer. That belongs in a cross-complaint.",
  "rules": ["CCP 431.30(c)"],
  "phase": "prepare",
  "forms": []
 },
 {
  "id": "verify",
  "text": "Verify the answer, because the complaint is verified. The defendant signs the verification; an attorney or other person may sign only in the circumstances CCP 446 allows, stating why. An officer may verify for a corporation. A public entity, or its officer in an official capacity, need not verify its answer.",
  "rules": ["CCP 446(a)"],
  "phase": "prepare",
  "when": "verified and not economicLitigation",
  "forms": []
 },
 {
  "id": "no-verification",
  "text": "The answer need not be verified, even though the complaint is: this is a limited civil case.",
  "rules": ["CCP 92(b)"],
  "phase": "prepare",
  "when": "verified and economicLitigation",
  "forms": []
 },
 {
  "id": "sign",
  "text": "The pleading is signed by at least one attorney of record in the attorney's own name, or by the party if not represented, and states the signer's address and telephone number. Signing it certifies that it isn't presented for an improper purpose and that its claims, defenses and denials are warranted.",
  "rules": ["CCP 128.7(a)", "CCP 128.7(b)", "CCP 446(a)"],
  "phase": "prepare",
  "forms": []
 },
 {
  "id": "cross-complaint",
  "text": "Prepare the cross-complaint against the plaintiff as a separate document. It must be filed before or at the same time as the answer; filing it later needs leave of court.",
  "rules": ["CCP 428.10(a)", "CCP 428.40", "CCP 428.50(a)", "CCP 428.50(c)"],
  "phase": "prepare",
  "when": "xc = yes",
  "forms": []
 },
 {
  "id": "cross-complaint-service",
  "text": "File it with proof of service on the parties who have appeared. If it adds new parties, serve them with a summons on the cross-complaint, the most recent complaint and any answers to it, and file proof of service on them within 30 days of filing the cross-complaint.",
  "rules": ["CCP 428.60", "CRC 3.110(c)", "CRC 3.222"],
  "phase": "prepare",
  "when": "xc = yes",
  "forms": []
 },
 {
  "id": "cross-complaint-adr",
  "text": "Serve the court's ADR information package on any new parties with the cross-complaint.",
  "rules": ["CRC 3.221(c)"],
  "phase": "prepare",
  "when": "xc = yes",
  "forms": []
 },
 {
  "id": "counter-cover-sheet",
  "text": "The defendant may file and serve a counter Civil Case Cover Sheet (CM-010), no later than its first appearance, designating the case as complex or not complex.",
  "rules": ["CRC 3.402"],
  "phase": "prepare",
  "when": "complex = yes",
  "forms": ["ca-cm-010"]
 },
 {
  "id": "first-paper-fee-unlimited",
  "text": "First paper filing fee: {fee.amount} ({fee.label}). Each defendant filing separately or jointly pays its own first paper fee.",
  "rules": ["GC 70612", "Fee Schedule item 5"],
  "localCite": "{fee.localCite}",
  "note": "{fee.note}",
  "phase": "fees",
  "when": "cls = unlimited",
  "forms": []
 },
 {
  "id": "first-paper-fee-limited-over-10k",
  "text": "First paper filing fee: {fee.amount} ({fee.label}). Each defendant filing separately or jointly pays its own first paper fee.",
  "rules": ["GC 70614(a)", "Fee Schedule item 9"],
  "localCite": "{fee.localCite}",
  "note": "{fee.note}",
  "phase": "fees",
  "when": "cls = limitedOver10k",
  "forms": []
 },
 {
  "id": "first-paper-fee-limited-up-to-10k",
  "text": "First paper filing fee: {fee.amount} ({fee.label}). Each defendant filing separately or jointly pays its own first paper fee.",
  "rules": ["GC 70614(b)", "Fee Schedule item 12"],
  "localCite": "{fee.localCite}",
  "note": "{fee.note}",
  "phase": "fees",
  "when": "cls = limitedUpTo10k",
  "forms": []
 },
 {
  "id": "cross-complaint-amount-fee",
  "text": "If the cross-complaint raises the amount at issue from $10,000 or less to more than $10,000 (up to $25,000), add the difference between the first paper fees: $145 at the statewide rate.",
  "rules": ["GC 70613.5(b)", "Fee Schedule item 14"],
  "note": "The amount can differ in a court with a local courthouse construction surcharge; see the fee schedule's appendix.",
  "phase": "fees",
  "when": "xc = yes and cls = limitedUpTo10k",
  "forms": []
 },
 {
  "id": "reclassification-fee",
  "text": "If the cross-complaint reclassifies the case from limited to unlimited civil, the reclassification fee is $140.",
  "rules": ["GC 70619", "CCP 403.060", "Fee Schedule item 15"],
  "phase": "fees",
  "when": "xc = yes and limited",
  "forms": []
 },
 {
  "id": "complex-fee",
  "text": "Complex case fee: $1,000 for each defendant, paid with its first paper if the case is designated or counterdesignated complex (all defendants together pay no more than $18,000).",
  "rules": ["GC 70616(b)", "Fee Schedule item 22"],
  "phase": "fees",
  "when": "complex = yes",
  "forms": []
 },
 {
  "id": "file",
  "text": "File the answer with the clerk.",
  "rules": ["CCP 465"],
  "phase": "file",
  "forms": [],
  "court": { "detail": "efiling.represented", "verify": "local rules on whether represented parties must e-file" }
 },
 {
  "id": "first-efiling",
  "rules": [],
  "phase": "file",
  "forms": [],
  "court": { "detail": "efiling.firstEfiling", "verify": "local rules on providing an electronic service address" }
 },
 {
  "id": "serve",
  "text": "Serve a copy on the plaintiff's attorney (or the plaintiff, if self-represented) and file the proof of service: POS-040 for service by mail or in person, POS-050 for electronic service.",
  "rules": ["CCP 465"],
  "phase": "serve",
  "forms": ["ca-pos-040", "ca-pos-050"]
 },
 {
  "id": "case-questionnaire",
  "text": "If the plaintiff served a case questionnaire with the complaint, serve the defendant's completed case questionnaire (DISC-010) on the plaintiff with the answer.",
  "rules": ["CCP 93(b)"],
  "phase": "serve",
  "when": "economicLitigation",
  "forms": ["ca-disc-010"]
 },
 {
  "id": "due-unlawful-detainer",
  "text": "File and serve by {due}: {due.how}.",
  "rules": ["CCP 1167(a)"],
  "note": "If service was completed by mail or in person through the Secretary of State's address confidentiality program, add five court days (CCP 1167(b)).",
  "phase": "serve",
  "when": "ud",
  "forms": [],
  "deadline": { "name": "due", "type": "courtDaysAfter", "from": "served", "days": 10, "how": "10 days after service, excluding Saturdays, Sundays and judicial holidays" }
 },
 {
  "id": "due-order",
  "text": "File and serve by {due}: {due.how}.",
  "rules": ["CRC 3.110(e)"],
  "phase": "serve",
  "when": "not ud and ext = order",
  "forms": [],
  "deadline": { "name": "due", "type": "date", "from": "extDate", "how": "the date in the court's order" }
 },
 {
  "id": "due-stipulation",
  "text": "File and serve by {due}: {due.how}.",
  "rules": ["CCP 412.20(a)(3)", "CRC 3.110(d)"],
  "phase": "serve",
  "when": "not ud and ext = stip",
  "forms": [],
  "deadline": { "name": "due", "type": "daysAfter", "from": "served", "days": 45, "nextCourtDay": true, "how": "30 days after service plus the agreed 15-day extension" }
 },
 {
  "id": "due",
  "text": "File and serve by {due}: {due.how}.",
  "rules": ["CCP 412.20(a)(3)"],
  "phase": "serve",
  "when": "not ud and not ext in (stip, order)",
  "forms": [],
  "deadline": { "name": "due", "type": "daysAfter", "from": "served", "days": 30, "nextCourtDay": true, "how": "30 days after service" }
 },
 {
  "id": "unlawful-detainer-department",
  "rules": [],
  "phase": "file",
  "when": "ud",
  "forms": [],
  "court": { "detail": "departments.unlawfulDetainer", "verify": "local rules on the department that hears unlawful detainer cases" }
 },
 {
  "id": "stipulated-extension",
  "text": "The parties can agree in writing, without leave of court, to one 15-day extension beyond the 30 days.",
  "rules": ["CRC 3.110(d)"],
  "phase": "deadlines",
  "when": "not ud and ext != stip",
  "forms": []
 },
 {
  "id": "court-extension",
  "text": "Beyond that, the court can extend the time on a party's application, filed before the time to respond has run.",
  "rules": ["CRC 3.110(e)"],
  "phase": "deadlines",
  "when": "not ud",
  "forms": []
 },
 {
  "id": "local-extension",
  "rules": [],
  "phase": "deadlines",
  "when": "not ud",
  "forms": [],
  "court": { "detail": "rules.extensionToRespond", "verify": "local rules on applications to extend time to respond" }
 },
 {
  "id": "petition-to-arbitrate",
  "text": "Instead of an answer, a defendant with an arbitration agreement can file a petition to compel arbitration. If the petition is denied, the defendant has 15 days after the denial to plead to the complaint.",
  "rules": ["CCP 1281.7", "CCP 1281.2"],
  "phase": "deadlines",
  "when": "not ud",
  "forms": []
 },
 {
  "id": "default",
  "text": "If no response is served in time and no extension is granted, the plaintiff must request entry of default within 10 days after the time has run.",
  "rules": ["CRC 3.110(g)"],
  "phase": "deadlines",
  "when": "not ud",
  "forms": []
 },
 {
  "id": "case-management",
  "text": "Calendar the case management conference: unless the court orders otherwise, meet and confer no later than 30 calendar days before the initial one, and file and serve a Case Management Statement (CM-110) no later than 15 calendar days before each one.",
  "rules": ["CRC 3.724", "CRC 3.725(a)", "CRC 3.725(c)"],
  "phase": "after",
  "when": "not ud",
  "forms": ["ca-cm-110"]
 },
 {
  "id": "jury-fee",
  "text": "If the defendant wants a jury and no party on its side has paid, pay the nonrefundable $150 jury fee on or before the date of the initial case management conference. If the defendant hadn't appeared before that conference, or first appears more than 365 calendar days after the complaint was filed, it is due at least 25 calendar days before the date first set for trial. If no case management conference is scheduled, it is due no later than 365 calendar days after the complaint was filed.",
  "rules": ["CCP 631(b)", "CCP 631(c)(2)", "CCP 631(c)(4)"],
  "phase": "after",
  "when": "not ud",
  "forms": []
 },
 {
  "id": "demurrer-to-answer",
  "text": "A plaintiff may demur to the answer within 10 days after it is served.",
  "rules": ["CCP 430.40(b)"],
  "phase": "after",
  "when": "not ud",
  "forms": []
 },
 {
  "id": "cross-complaint-response",
  "text": "Each party served with the cross-complaint has 30 days after service to respond to it.",
  "rules": ["CCP 432.10"],
  "phase": "after",
  "when": "not ud and xc = yes",
  "forms": []
 },
 {
  "id": "amended-complaint",
  "text": "If the complaint is amended, answer the amendments, or the complaint as amended, within 30 days after they are served, or other time the court directs. Otherwise default can be entered.",
  "rules": ["CCP 471.5(a)"],
  "phase": "after",
  "when": "not ud",
  "forms": []
 },
 {
  "id": "jury-fee-unlawful-detainer",
  "text": "If a jury is wanted, the $150 jury fee in an unlawful detainer is due at least five days before the date set for trial.",
  "rules": ["CCP 631(b)", "CCP 631(c)(1)"],
  "phase": "after",
  "when": "ud",
  "forms": []
 },
 {
  "id": "judge-pro-tem",
  "rules": [],
  "phase": "after",
  "when": "not ud",
  "forms": [],
  "court": { "detail": "rules.judgeProTem", "verify": "local rules on temporary judges" }
 }
]
